import React from 'react';
import { message } from 'antd';
import { object, func } from 'prop-types';

import {
  User,
  UserTop,
  UserLeft,
  UserRight,
  UserImage,
  UserName,
  UserRole,
  UserEmail,
  Deleted,
  DropdownS,
  WaitingForResponse,
} from './styled-components';

import Overlay from './dropdown-overlay';
import { getAvatarUrl } from '../../../../utils';
import { USER_ROLES } from '../../../../api/constants';
import { Tooltip } from '../../../../components/popovers';
import { SvgIcon } from '../../../../components/svg-icon';
import copyToClipboard from '../../../../utils/copyToClipboard';


const { ADMIN, SUPER_ADMIN, SALES_AGENT } = USER_ROLES;

const UserListItem = ({
  user,
  reInviteUser,
  onDeleteUser,
  onRestoreUser,
  onChangeUserRole,
  onCancelInvitation,
  authorizedUserActions,
}) => (
  <User
    key={user._id}
    isActivated={user.isActivated}
  >
    {user.isActivated && !user.isDeleted &&
    <UserLeft>
      <UserImage src={getAvatarUrl(user.profileImage)} />
    </UserLeft>
    }

    <UserRight>
      <UserTop>
        <Tooltip title={user.fullName}>
          <UserName isWithRole={[ADMIN, SUPER_ADMIN, SALES_AGENT].includes(user.role)}>
            {user.fullName}
          </UserName>
        </Tooltip>

        {
          !user.isDeleted &&
          (user.role === ADMIN &&
            <UserRole>{user.role}</UserRole> ||
            user.role === SUPER_ADMIN &&
            <UserRole>owner</UserRole> ||
            user.role === SALES_AGENT &&
            <UserRole>agent</UserRole>
          )
        }
      </UserTop>

      <UserEmail
        onClick={() => copyToClipboard(
          user.email,
          () => message.success('Email successfully copied'),
        )}
      >
        {user.email}
      </UserEmail>

      {!user.isActivated && !user.isDeleted &&
        <WaitingForResponse>waiting for response</WaitingForResponse>
      }

      {user.isDeleted &&
        <Deleted>Archived</Deleted>
      }

      {user.isActivated && !user.isDeleted && user.isGmailConnected && (
        <Tooltip title={`${user.fullName} connected GMAIL`}>
          <SvgIcon
            style={{
              width: '15px',
              height: '15px',
              position: 'absolute',
              right: '12px',
              bottom: '10px',
            }}
            type="gmail"
            isWithoutHover
          />
        </Tooltip>
      )}
    </UserRight>

    {
      (authorizedUserActions.canArchive ||
        authorizedUserActions.canRestore ||
        authorizedUserActions.canReInvite ||
        authorizedUserActions.canCancelInvite ||
        authorizedUserActions.canPromoteToAdmin)
      && <DropdownS
        overlay={Overlay(
          user._id,
          reInviteUser,
          onDeleteUser,
          onRestoreUser,
          onChangeUserRole,
          onCancelInvitation,
          authorizedUserActions,
        )}
      />
    }
  </User>
);

UserListItem.propTypes = {
  user: object.isRequired,
  reInviteUser: func.isRequired,
  onDeleteUser: func.isRequired,
  onRestoreUser: func.isRequired,
  onChangeUserRole: func.isRequired,
  onCancelInvitation: func.isRequired,
  authorizedUserActions: object.isRequired,
};

export default UserListItem;



// WEBPACK FOOTER //
// ./src/modals/manage-users-modal/list-users/user-list-item/index.js